import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Drawer, Typography, Avatar, Stack, Tooltip, Button, Popover, Container } from '@mui/material';
import Iconify from '../../../components/iconify';
// mock
import account from '../../../_mock/account';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import Logo from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import NavSection from '../../../components/nav-section';
//
import navConfig from './config';
import config from '../../../config.json'

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};



export default function Nav({ openNav, onCloseNav }) {
  const user = JSON.parse(localStorage.getItem('userData'))
  const { pathname } = useLocation();
  const [openRealeaseNotes, setOpenRealeaseNotes] = useState(null);
  const navigate = useNavigate();

  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const openPopUpRealeaseNotes = (event) => {
    setOpenRealeaseNotes(event.currentTarget);
  }

  const closePopUpRealeaseNotes = () => {
    setOpenRealeaseNotes(null);
  };

  const logout = () => {
    localStorage.removeItem('userData');
    localStorage.removeItem('userToken');
    config.user = {}
    navigate('/', { replace: true })
  };

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
        <Logo />
      </Box>

      <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none">
          <StyledAccount>
            <Avatar src={user?.foto || account.photoURL} alt={user?.nome}>
              {!user?.foto && user?.nome?.charAt(0).toUpperCase()}
            </Avatar>

            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {user?.nome}
              </Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {account.role}
              </Typography>
            </Box>
          </StyledAccount>
        </Link>
      </Box>

      <NavSection data={navConfig} />

      <Box sx={{ flexGrow: 1 }} />

      <Stack sx={{ px: 2.5, pb: 3, mt: 10, alignItems: 'center' }}>
        <Button size="small" variant="outlined" onClick={logout}>
          Sair
        </Button>
        <Stack alignItems="center" spacing={3} sx={{ pt: 5, borderRadius: 2, position: 'relative' }}>
          1.{config.globalVersion}.{config.versao}
        </Stack>
        <Stack alignItems="center" sx={{ borderRadius: 2, position: 'relative' }}>
          <Tooltip title=''>
            <Button variant="text" onClick={(e) => openPopUpRealeaseNotes(2)}>
              <Iconify icon={'eva:alert-circle-outline'} />
            </Button>
          </Tooltip>
        </Stack>
      </Stack>

    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>


  );
}